
let tool = {
	install(Vue) {
		Vue.prototype.$tool = tool;
		Vue.prototype.$isPc = () => {
			return document.documentElement.clientWidth > 768;
		};
	},
	isPc() {
		return document.documentElement.clientWidth > 768;
	},
	/* 获取getGlobalUserId*/
	getGlobalUserId() {
		if (Cookies.get('globalUserId')) {
			return Cookies.get('globalUserId');
		}
		var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0; var v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
		uuid = uuid.replace(/-/g, '');
		Cookies.set('globalUserId', uuid, { expires: 365 });
		return uuid;
	},
	/* 获取地址栏参数*/
	getUrlKey(name) {
		let value = decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || ['', ''])[1].replace(/\+/g, '%20')) || '';
		// if (value == 'undefined' || value == undefined || value == 'null' || value == null) {
		//     value = '';
		// }
		// if (!value) {
		// 	value = this.parseUrlKey(name);
		// }
		return value;
	},
	/* 获取地址栏参数-备用方法*/
	parseUrlKey(name) {
		let query = qs.parse(location.search.substring(1));
		let value = '';
		if (Object.keys(query).indexOf(name) != -1) {
			value = query[name];
		}
		// if (value == 'undefined' || value == undefined || value == 'null' || value == null) {
		//     value = '';
		// }
		return value;
	},
	/* 是否是微信浏览器*/
	isWechatBrowser() {
		return window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger';
	},
	/* 获取时间*/
	getTime() {
		if (window.ec_time_request) {
			if (this.getUrlKey('ec_time')) {
				return Math.round(new Date().getTime() / 1000, 10) - this.getUrlKey('ec_time');
			} else {
				return Math.round(new Date().getTime() / 1000, 10) - window.ec_time;
			}
		} else {
			if (this.getUrlKey('ec_time')) {
				return Math.round(new Date().getTime() / 1000, 10) - this.getUrlKey('ec_time');
			}else{
				return Math.round(new Date().getTime() / 1000, 10);
			}
		}
	},
	/* 数组排序*/
	sortKey(array, key) {
		return array.sort(function (a, b) {
			var x = a[key];
			var y = b[key];
			return x > y ? -1 : x < y ? 1 : 0;
		});
	},
	/* 校验是否数字*/
	isNumber(val) {
		var regPos = /^\d+(\.\d+)?$/; // 非负浮点数
		var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; // 负浮点数
		if (regPos.test(val) || regNeg.test(val)) {
			return true;
		} else {
			return false;
		}
	},
	/* 去除空格*/
	trim(str) {
		return str.replace(/(^\s*)|(\s*$)/g, '');
	},
	/* 深度拷贝*/
	deepClone(data) {
		if (typeof data === 'string') {
			return new String(data.valueOf());
		} else if (typeof data === 'number') {
			return new Number(data.valueOf());
		} else if (typeof data === 'boolean' || typeof data === 'undefined') {
			return data;
		} else if (Array.isArray(data)) {
			let _arr = [];
			data.forEach(item => { _arr.push(item); });
			return _arr;
		} else if (typeof data === 'object') {
			let _dest = JSON.parse(JSON.stringify(data));
			return _dest;
		}
	},
	/* 构造数组，num个元素一组*/
	constructArrayByNum(data, num = 3) {
		let point = 0;
		let dest = [];
		for (let i = 0; i < data.length; i++) {
			if (i >= point * num && i < (point + 1) * num) {
				if (dest.length == point) {
					dest[point] = [data[i]];
				} else {
					dest[point].push(data[i]);
				}
			}
			if ((i + 1) % num == 0) {
				point++;
			}
		}
		return dest;
	},
	/* 构造数组，num个元素一组*/
	constructArrayByField(data, field) {
		let temp = {};
		let dest = [];
		data.map((item, index) => {
			if (temp[item[field]]) {
				temp[item[field]].list.push(item);
			} else {
				temp[item[field]] = {
					field: item[field],
					list: [item]
				};
			}
		});
		for (let key in temp) {
			dest.push(temp[key]);
		}
		return dest;
	},
	/* 从数组提取某一个field值组成数组*/
	arrayFieldValue(data, field) {
		data.map(item => {
			item[field + 'Value'] = [];
			item.list.map(one => {
				if (item[field + 'Value'].indexOf(one[field]) == -1) {
					item[field + 'Value'].push(one[field]);
				}
			});
		});
		return data;
	},
	/* 时间戳转时间*/
	timestampToTime(timestamp) {
		let date = new Date(timestamp * 1000);// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
		let Y = date.getFullYear() + '-';
		let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
		let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
		let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
		let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
		let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
		return Y + M + D + h + m + s;
	},
	// 时间戳转年份
	timestampToYear(timestamp) {
		let date = new Date(timestamp * 1000);// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
		return date.getFullYear();
	},
	// 时间戳转月份
	timestampToMonth(timestamp, zero = true) {
		let date = new Date(timestamp * 1000);// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
		if (zero) {
			return (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
		} else {
			return (date.getMonth() + 1 < 10 ? (date.getMonth() + 1) : date.getMonth() + 1);
		}
	},
	// 时间戳转日
	timestampToDay(timestamp, zero = true) {
		let date = new Date(timestamp * 1000);// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
		if (zero) {
			return (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
		} else {
			return (date.getDate() < 10 ? date.getDate() : date.getDate());
		}
	},
	// 时分秒转 时分AM
	HourMinuteToStr(str) {
		let hour = str.substring(0, 2);
		let out = str.substring(0, 5);
		str = hour > 12 ? 'PM' : 'AM';
		return out + str;
	},
	/* 验证邮箱*/
	verifyEmail(email) {
		let reg = /^([A-Za-z0-9_|\\\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/;
		if (!reg.test(email)) {
			return false;
		} else {
			return true;
		}
	},
	/* 验证手机号-国内短信*/
	verifyPhone(phone) {
		// 国内短信
		let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
		if (phone.match(reg) == null) {
			return false;
		} else {
			return true;
		}
	},
	/* 微信授权获取openid*/
	goWxRedirect() {
		let url = config.gateway.project + '/wechat/auth?url=' + encodeURIComponent(window.location.href);
		window.location.href = url;
	},
	// localStorage取值
	getStorage(key) {
		let value = localStorage.getItem(key);
		// if (value == 'undefined' || value == undefined || value == 'null' || value == null) {
		//     value = '';
		// }
		return value;
	},
	trimStorage(key) {
		let value = '';
		value = localStorage.getItem(key);
		if (value == 'undefined' || value == undefined || value == 'null' || value == null) {
			value = '';
		}
		return value;
	},
	// 校验合法url
	verifyUrl(str) {
		str = str.toString();
		if (str.indexOf('javascript:') != -1) {
			return false;
		} else {
			if (str.match(/(http|https):\/\/([\w.]+\/?)\S*/ig)) {
				return true;
			} else {
				return false;
			}
		}
	},
	// 数组去重
	arrayUnique(arr) {
		return [...new Set(arr)];
	},
	// 获取窗口宽高
	getWindowSize() {
		let windowWidth = window.innerWidth;
		let windowHeight = window.innerHeight;
		if (typeof windowWidth !== 'number') {
			if (document.compatMode === 'CSS1Compat') {
				windowWidth = document.documentElement.clientWidth;
				windowHeight = document.documentElement.clientHeight;
			} else {
				windowWidth = document.body.clientWidth;
				windowHeight = window.body.clientHeight;
			}
		}
		return {
			width: windowWidth,
			height: windowHeight
		};
	},
};
export default tool;
